import {
    type AuditActorName,
    type AuditFilterChange,
    type AuditLogEntry,
    addAuditFilters,
    describeActor,
    useAuditText,
} from '@/domain/auditLog';

import CellFilterButton from './CellFilterButton';
import CellLines from './CellLines';

import styles from './ActorCell.module.scss';

interface ActorCellProps {
    entry: AuditLogEntry;
    onFilter: (change: AuditFilterChange) => void;
}

function ActorName({ name, text }: { name: AuditActorName; text: string }) {
    if (name.kind === 'text') return <>{text}</>;
    return (
        <span className={styles.email}>
            <span className={styles.localPart}>{name.localPart}</span>
            <span className={styles.domain}>{name.domain}</span>
        </span>
    );
}

export default function ActorCell({ entry, onFilter }: ActorCellProps) {
    const render = useAuditText();
    const actor = describeActor(entry);
    const text = render(actor.text);
    const name = <ActorName name={actor.name} text={text} />;
    const { filter, impersonator } = actor;
    const impersonatorText = impersonator === null ? undefined : render(impersonator.text);

    return (
        <CellLines
            first={
                filter === null ? (
                    <span className={styles.name}>{name}</span>
                ) : (
                    <CellFilterButton
                        value={text}
                        onFilter={() => onFilter(addAuditFilters(filter))}>
                        {name}
                    </CellFilterButton>
                )
            }
            firstTitle={text}
            second={
                impersonator === null || impersonatorText === undefined ? null : (
                    <span className={styles.impersonator}>
                        <CellFilterButton
                            value={impersonatorText}
                            onFilter={() => onFilter(addAuditFilters(impersonator.filter))}>
                            {impersonatorText}
                        </CellFilterButton>
                    </span>
                )
            }
            secondTitle={impersonatorText}
        />
    );
}
